import { render, staticRenderFns } from "./GestaoDePedidoView.vue?vue&type=template&id=4ae403ac"
import script from "./GestaoDePedidoView.vue?vue&type=script&lang=js"
export * from "./GestaoDePedidoView.vue?vue&type=script&lang=js"
import style0 from "./GestaoDePedidoView.vue?vue&type=style&index=0&id=4ae403ac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports